module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/mv_photowedding_03@2x-aaad75c7bc1e3066479bab43c7b5eb9a.webp";